import React from "react";
import { Button, Icon, Toast } from "antd-mobile";
import { post } from "../../utils/request";
import { href, encode } from "../../utils/util";
import PapersUploadGR from "../modules/papersUpload_GR"; // 个人
import PapersUploadQY from "../modules/papersUpload_QY"; // 企业
import AttestationType from "../modules/attestationType";
import AttestationStatus from "../modules/attestationStatus";
import AgreementText from "../../authCertificate/modules/agreementText";
import DigitalText from "../../authCertificate/modules/digitalText";

import api from "../api";
import { SSQUrl } from "../../utils/config";

import "./index.less";
let submitType;
class IdentityVerification extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            iconType: false,
            phoneNumber: "", //手机号
            identifyCode: "", //验证码
            caType: "MOBILE", //认证方式： MOBILE（手机号验证），PERSONAL（刷脸认证）
            cerificationNo: "", //身份证号码
            customerName: "", //客户姓名OR企业名称
            front: "", //身份证正面
            back: "", //身份证反面
            status: "", // 是否认证成功状态
            agreementTextStatus: false, //协议文案展示状态
            digitalTextStatus: false, //协议文案展示状态
            urlOps: {
                // userType   {string 4: 个人 123: 企业}
            },

            legalPersonName: "", //法人姓名
            authBook: "", //授权书
            orgIdentity: "", //营业执照
            regCode: "", // 统一社会信用代码
            name: "", // 身份证姓名
            defaultDataSFZ: {
                front: "",
            },
            defaultDataYYZZ: {
                orgIdentity: "",
            },
            personalIdentity3Key: "",
            certification: "",
            plateformType: "EQB",
            isHideNoAuth: false,
        };
    }

    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    this.getPlateformType();
                    this.getQueryCustomerInfo();
                }
            );
        }
    }

    // 查询默认认证平台类型
    getPlateformType = () => {
        const { urlOps } = this.state;
        let url =
            "/gateway/manageBedrock/bdDictionarycs/selectBdDictionary" +
            "?app_stoken=" +
            urlOps.app_stoken;
        post({
            url,
            data: {
                dictionaryCode: "SIGN_PLATEFORM_TYPE",
            },
        }).then(
            (res) => {
                this.setState({
                    plateformType: res.data.dictionaryValue,
                });
            },
            (res) => {
                console.log("查询查询默认认证平台类型失败", res);
                if (res.code == "-1") {
                    Toast.info("登录失效", 1);
                } else {
                    Toast.info("查询查询默认认证平台类型失败", 1);
                }
            }
        );
    };

    // 查询客户信息
    getQueryCustomerInfo = () => {
        const { urlOps } = this.state;
        post({
            url: api.queryCustomerInfo + "?app_stoken=" + urlOps.app_stoken,
            data: {},
        }).then(
            (res) => {
                console.log("查询客户信息", res);
                if (res.result === "success") {
                    const accessory = res.data.accessory
                        ? JSON.parse(res.data.accessory)
                        : [];
                    let cerificationNo =
                            res.data.tiertype === "4"
                                ? res.data.idcard
                                : res.data.legalpersonidcard,
                        customerName = res.data.realname,
                        name = res.data.name,
                        front = "",
                        back = "",
                        orgIdentity = "";

                    let isHideNoAuth =
                        res.data.currentCustomerType === "company" &&
                        res.data.defaultTenant.tenantType == "HGC";
                    for (var i = 0; i < accessory.length; i++) {
                        if (
                            accessory[i].attachmentType === "ID_CARD_FRONT" ||
                            accessory[i].attachmentType ===
                                "AGENT_ID_CARD_FRONT"
                        ) {
                            front = accessory[i].dataImg;
                            continue;
                        }
                        if (
                            accessory[i].attachmentType === "ID_CARD_BACK" ||
                            accessory[i].attachmentType === "AGENT_ID_CARD_BACK"
                        ) {
                            back = accessory[i].dataImg;
                            continue;
                        }
                        if (
                            accessory[i].attachmentType === "BUSINESS_LICENCE"
                        ) {
                            orgIdentity = accessory[i].dataImg;
                            continue;
                        }
                        if (
                            accessory[i].attachmentType === "AGENT_AUTH_LETTER"
                        ) {
                            var authBook = accessory[i].dataImg;
                            continue;
                        }
                    }

                    if (res.data.tiertype === "4") {
                        this.setState({
                            defaultDataSFZ: {
                                front,
                                back,
                            },
                            cerificationNo: res.data.idcard,
                            certification: res.data.certification,
                            customerName: res.data.realname,
                            front,
                            back,
                            isHideNoAuth,
                        });
                    } else {
                        if (res.data.agentname) {
                            this.setState({
                                caType: "AUTH",
                                defaultDataSFZ: {
                                    front,
                                    back,
                                },
                                defaultDataYYZZ: {
                                    orgIdentity,
                                },
                                front,
                                back,
                                orgIdentity,
                                authBook,
                                regCode: res.data.socialcreditcode,
                                legalPersonName: res.data.legalrepresentative,
                                customerName: res.data.realname,
                                cerificationNo: res.data.agentidcard,
                                name: res.data.agentname,
                                certification: res.data.certification,
                            });
                        } else {
                            this.setState({
                                defaultDataSFZ: {
                                    front,
                                    back,
                                },
                                defaultDataYYZZ: {
                                    orgIdentity,
                                },
                                front,
                                back,
                                orgIdentity,
                                authBook,
                                regCode: res.data.socialcreditcode,
                                legalPersonName: res.data.legalrepresentative,
                                customerName: res.data.realname,
                                cerificationNo: res.data.legalpersonidcard,
                                name: res.data.legalrepresentative,
                                certification: res.data.certification,
                            });
                        }
                    }
                } else {
                    if (res.code == "-1") {
                        Toast.info("登录失效", 1);
                    } else {
                        Toast.info("查询客户信息失败", 1);
                    }
                }
            },
            (res) => {
                console.log("查询客户信息失败", res);
                if (res.code == "-1") {
                    Toast.info("登录失效", 1);
                } else {
                    Toast.info("查询客户信息失败", 1);
                }
            }
        );
    };

    submit = () => {
        let {
            iconType,
            caType,
            certification,
            phoneNumber,
            identifyCode,
            cerificationNo,
            customerName,
            front,
            back,
            regCode,
            legalPersonName,
            name,
            orgIdentity,
            authBook,
            urlOps,
            personalIdentity3Key,
            SQZSUrl,
            plateformType,
        } = this.state;
        let _this = this;
        // 防重复点击
        if (submitType) {
            return;
        }
        window.Countly.q.push([
            "add_event",
            {
                key: "Member_PersonalInformation_CertificationSubmit_Ck",
                segmentation: {},
            },
        ]);
        React.$hlInsight.track(
            "Member_PersonalInformation_CertificationSubmit_Ck",
            {}
        );

        if (caType !== "PERSONAL") {
            this.setState(
                {
                    status: "loading",
                },
                () => {
                    let url = "",
                        ops = {};
                    if (urlOps.currentCustomerType === "personal") {
                        url = api.personalCertificate;
                        ops = {
                            caType: "MOBILE",
                            customerName: customerName,
                            identity: cerificationNo,
                            phoneNumber: phoneNumber,
                            identityImage: {
                                front: front,
                                back: back,
                            },
                        };
                        if (plateformType === "SSQ") {
                            ops.identifyCode = identifyCode;
                        }
                    } else {
                        url = api.organizationPermission;
                        if (caType === "MOBILE") {
                            ops = {
                                caType: "MOBILE",
                                customerName: customerName,
                                identity: regCode,
                                legalPersonName: legalPersonName,
                                legalPersonIdentityNo: cerificationNo,
                                phoneNumber: phoneNumber,
                                identityImage: {
                                    front: front,
                                    back: back,
                                    orgIdentity: orgIdentity,
                                },
                            };

                            if (plateformType === "SSQ") {
                                ops.identifyCode = identifyCode;
                            }
                        } else {
                            ops = {
                                caType: "AUTH",
                                customerName: customerName,
                                identity: regCode,
                                legalPersonName: legalPersonName,
                                phoneNumber: phoneNumber,
                                authPerson: name,
                                authIdentity: cerificationNo,
                                authMobileNumber: phoneNumber,
                                identityImage: {
                                    front: front,
                                    back: back,
                                    orgIdentity: orgIdentity,
                                    // authBook: authBook,
                                },
                            };

                            if (plateformType === "SSQ") {
                                ops.identifyCode = identifyCode;
                                ops.identityImage.authBook = authBook;
                            }
                        }
                    }

                    submitType = true;
                    post({
                        url: url + "?app_stoken=" + urlOps.app_stoken,
                        headers: {
                            "Content-Type": "application/json",
                        },
                        data: { ...ops, personalIdentity3Key, plateformType },
                    }).then(
                        (res) => {
                            submitType = false;
                            console.log("手机认证", res);
                            if (res.result === "success") {
                                if (plateformType === "EQB") {
                                    // 小程序跳转
                                    if (this.state.urlOps.source === "XCX") {
                                        window.location.href =
                                            res.data.eqb.longUrl;
                                    } else {
                                        window.location.href = res.data.eqb.url;
                                    }
                                } else {
                                    if (certification == "1") {
                                        href(`/identificationResult`);
                                    } else {
                                        href(
                                            `/identificationResult?type=${ops.caType}`
                                        );
                                    }
                                }
                            } else {
                                this.setState({
                                    status: "error",
                                });
                                if (res.code == "-1") {
                                    Toast.info("登录失效", 1);
                                } else {
                                    Toast.info(res.msg);
                                    // Toast.info("认证失败", 1);
                                }
                            }
                        },
                        (res) => {
                            submitType = false;
                            console.log("认证失败", res);
                            this.setState({
                                status: "error",
                            });
                            if (res.code == "-1") {
                                Toast.info("登录失效", 1);
                            } else {
                                Toast.info("认证失败", 1);
                            }
                        }
                    );
                }
            );
        } else {
            let ops = {};
            const returnUrl =
                window.location.origin +
                window.location.pathname +
                "#/identificationResult?url=" +
                encode(window.location.href);
            if (urlOps.currentCustomerType === "personal") {
                ops = {
                    from: "H5",
                    userType: 1,
                    mobileNumber: urlOps.mobileNumber,
                    name: customerName,
                    identity: cerificationNo,
                    returnUrl: returnUrl,
                    callbackHost: SSQUrl,
                    idCardFront: front,
                    idCardBack: back,
                };
            } else {
                ops = {
                    from: "H5",
                    userType: 2,
                    mobileNumber: urlOps.mobileNumber,
                    name: customerName,
                    identity: regCode,
                    returnUrl: returnUrl,
                    callbackHost: SSQUrl,
                    legalPersonName: name,
                    legalPersonIdentityNo: cerificationNo,
                    idCardFront: front,
                    idCardBack: back,
                };
            }

            submitType = true;

            post({
                url:
                    api.getPersonalFaceCaUrl +
                    "?app_stoken=" +
                    urlOps.app_stoken,
                headers: {
                    "Content-Type": "application/json",
                },
                data: { ...ops, plateformType },
            }).then(
                (res) => {
                    submitType = false;
                    console.log("刷脸认证", res);
                    if (res.result === "success") {
                        window.location.href = res.data;
                    } else {
                        if (res.code == "-1") {
                            Toast.info("登录失效", 1);
                        } else {
                            Toast.info("刷脸认证失败", 1);
                        }
                    }
                },
                (res) => {
                    submitType = false;
                    console.log("刷脸认证失败", res);

                    if (res.code == "-1") {
                        Toast.info("登录失效", 1);
                    } else {
                        Toast.info("刷脸认证失败", 1);
                    }
                }
            );
        }
    };

    submitTypeStatus = () => {
        const {
            iconType,
            phoneNumber,
            identifyCode,
            caType,
            cerificationNo,
            customerName,
            front,
            back,
            // status,
            // agreementTextStatus,
            // digitalTextStatus,
            // legalPersonName,
            authBook,
            // orgIdentity,
            // regCode,
            // name,
            // urlOps,
            // defaultDataSFZ,
            // defaultDataYYZZ,
            // certification,
            plateformType,
        } = this.state;
        if (plateformType === "EQB") {
            return (
                (caType === "AUTH" &&
                    phoneNumber &&
                    // identifyCode &&
                    // authBook &&
                    cerificationNo &&
                    customerName &&
                    front &&
                    back &&
                    iconType) ||
                (caType === "MOBILE" &&
                    phoneNumber &&
                    // identifyCode &&
                    cerificationNo &&
                    customerName &&
                    front &&
                    back &&
                    iconType) ||
                (caType === "PERSONAL" &&
                    cerificationNo &&
                    customerName &&
                    front &&
                    back &&
                    iconType)
            );
        } else {
            return (
                (caType === "AUTH" &&
                    phoneNumber &&
                    identifyCode &&
                    cerificationNo &&
                    customerName &&
                    front &&
                    back &&
                    iconType &&
                    authBook) ||
                (caType === "MOBILE" &&
                    phoneNumber &&
                    identifyCode &&
                    cerificationNo &&
                    customerName &&
                    front &&
                    back &&
                    iconType) ||
                (caType === "PERSONAL" &&
                    cerificationNo &&
                    customerName &&
                    front &&
                    back &&
                    iconType)
            );
        }
    };

    render() {
        let {
            iconType,
            phoneNumber,
            identifyCode,
            caType,
            cerificationNo,
            customerName,
            front,
            back,
            status,
            agreementTextStatus,
            digitalTextStatus,
            legalPersonName,
            authBook,
            orgIdentity,
            regCode,
            name,
            urlOps,
            defaultDataSFZ,
            defaultDataYYZZ,
            certification,
            plateformType,
        } = this.state;

        return (
            <div className="IdentityVerificationBox">
                {urlOps.currentCustomerType === "personal" ? (
                    <div>
                        <div className="blockBox">
                            <h3>个人证件</h3>
                            <PapersUploadGR
                                defaultData={defaultDataSFZ}
                                name={customerName}
                                cerificationNo={cerificationNo}
                                onCancel={(
                                    cerificationNo,
                                    customerName,
                                    front,
                                    back
                                ) => {
                                    this.setState({
                                        cerificationNo,
                                        customerName,
                                        front,
                                        back,
                                    });
                                }}
                                urlOps={this.state.urlOps}
                            />
                        </div>
                        <div className="blockBox">
                            {/* <h3>请选择认证方式</h3> */}
                            <h3>手机认证</h3>
                            <AttestationType
                                fangShi={this.state.caType}
                                source={"GR"}
                                cerificationNo={cerificationNo}
                                customerName={customerName}
                                plateformType={plateformType}
                                onCancel={(
                                    phoneNumber,
                                    identifyCode,
                                    caType,
                                    personalIdentity3Key
                                ) => {
                                    this.setState({
                                        phoneNumber,
                                        identifyCode,
                                        caType,
                                        personalIdentity3Key,
                                    });
                                }}
                                urlOps={this.state.urlOps}
                            />
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="blockBox">
                            <h3>企业证件</h3>
                            <PapersUploadQY
                                defaultData={defaultDataYYZZ}
                                customerName={customerName}
                                regCode={regCode}
                                legalPerson={legalPersonName}
                                onCancel={(
                                    legalPersonName,
                                    customerName,
                                    orgIdentity,
                                    regCode
                                ) => {
                                    console.log(orgIdentity);
                                    this.setState({
                                        legalPersonName,
                                        customerName,
                                        orgIdentity,
                                        regCode,
                                    });
                                }}
                                urlOps={this.state.urlOps}
                            />
                        </div>
                        <div className="blockBox">
                            <h3>
                                个人证件
                                <div className="agreeBox">
                                    {!this.state.isHideNoAuth && (
                                        <label
                                            onClick={() => {
                                                this.setState({
                                                    caType:
                                                        this.state.caType ===
                                                        "AUTH"
                                                            ? "MOBILE"
                                                            : "AUTH",
                                                });
                                            }}
                                        >
                                            {this.state.caType === "AUTH" ? (
                                                <Icon type="check" />
                                            ) : (
                                                <Icon />
                                            )}
                                            <div>经办人或授权人认证</div>
                                        </label>
                                    )}
                                </div>
                            </h3>
                            <PapersUploadGR
                                defaultData={defaultDataSFZ}
                                selectSign="法定代表人"
                                fangShi={this.state.caType}
                                name={name}
                                cerificationNo={cerificationNo}
                                onCancel={(
                                    cerificationNo,
                                    name,
                                    front,
                                    back
                                ) => {
                                    this.setState({
                                        cerificationNo,
                                        name,
                                        front,
                                        back,
                                    });
                                }}
                                urlOps={this.state.urlOps}
                            />
                        </div>
                        <div className="blockBox">
                            <h3>
                                {this.state.caType === "AUTH"
                                    ? "授权书认证"
                                    : "手机认证"}
                            </h3>
                            <AttestationType
                                selectSign="法定代表人"
                                fangShi={this.state.caType}
                                phoneNumber={phoneNumber}
                                identifyCode={identifyCode}
                                source={"QY"}
                                cerificationNo={cerificationNo}
                                customerName={name}
                                regCode={regCode}
                                SQZSUrl={authBook}
                                plateformType={plateformType}
                                onCancel={(
                                    phoneNumber,
                                    identifyCode,
                                    caType,
                                    personalIdentity3Key,
                                    authBook
                                ) => {
                                    this.setState({
                                        phoneNumber,
                                        identifyCode,
                                        caType,
                                        authBook,
                                        personalIdentity3Key,
                                    });
                                }}
                                urlOps={this.state.urlOps}
                            />
                        </div>
                    </div>
                )}

                <div className="agreeBox">
                    <label
                        onClick={() => {
                            this.setState({
                                iconType: !iconType,
                            });
                        }}
                    >
                        {iconType ? <Icon type="check" /> : <Icon />}
                        <div>
                            我同意远程慧联对我提交的个人身份信息的保护办法
                            <a
                                onClick={() => {
                                    this.setState({
                                        agreementTextStatus: true,
                                    });
                                }}
                            >
                                《远程慧联如何保护您的信息》
                            </a>
                            <a
                                onClick={() => {
                                    this.setState({
                                        digitalTextStatus: true,
                                    });
                                }}
                            >
                                《数字证书使用协议》
                            </a>
                        </div>
                    </label>
                </div>
                <div className="queryBtnBox">
                    {
                        // certification === "1" && plateformType === "EQB" ? (
                        //     ""
                        // ) :
                        this.submitTypeStatus() ? (
                            <Button
                                type="primary"
                                onClick={this.submit}
                            >
                                确认提交
                            </Button>
                        ) : (
                            <Button
                                type="primary"
                                disabled
                            >
                                确认提交
                            </Button>
                        )
                    }
                    <div style={{ padding: "10px" }}>
                        个人身份信息将用于申请数字证书
                    </div>
                </div>
                <AttestationStatus
                    status={status}
                    caType={caType}
                    onRestart={() => {
                        this.submit();
                    }}
                    onQuit={(status) => {
                        this.setState({
                            status,
                        });
                    }}
                />
                {agreementTextStatus ? (
                    <AgreementText
                        agreementTextStatus={agreementTextStatus}
                        onQuit={(agreementTextStatus) => {
                            this.setState({
                                agreementTextStatus,
                            });
                        }}
                    />
                ) : (
                    ""
                )}
                {digitalTextStatus ? (
                    <DigitalText
                        digitalTextStatus={digitalTextStatus}
                        onQuit={(digitalTextStatus) => {
                            this.setState({
                                digitalTextStatus,
                            });
                        }}
                    />
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default IdentityVerification;



// WEBPACK FOOTER //
// ./src/identityVerification/index/index.js